module.exports = __webpack_public_path__ + "static/img/nylogo.6d563b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nylogo.png
// module id = BOSE
// module chunks = 1